import { Tag } from '../tag/Tag';
import { Text } from '../text';
import { Tooltip } from '../tooltip/Tooltip';

type TagItem = {
  id: string;
  name: string;
};

type Props = {
  /** 表示するタグ一覧 */
  tags: TagItem[];
  /** 最大表示件数（デフォルト: 2） */
  maxDisplay?: number;
  /** タグのサイズ */
  size?: 'default' | 'small';
};

/**
 * タグ一覧表示コンポーネント
 *
 * 最大 maxDisplay 件まで表示し、超過分は +N バッジで省略表示する。
 * 省略時は Tooltip で残りのタグ名を表示する。
 */
export const TagList = ({ tags, maxDisplay = 2, size = 'default' }: Props) => {
  if (tags.length === 0) return null;

  const visibleTags = tags.slice(0, maxDisplay);
  const overflowCount = tags.length - maxDisplay;
  const overflowTags = tags.slice(maxDisplay);

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visibleTags.map((tag) => (
        <Tag key={tag.id} size={size} className="max-w-[120px]">
          {tag.name}
        </Tag>
      ))}
      {overflowCount > 0 && (
        <Tooltip
          tooltipContent={
            <div className="flex flex-wrap gap-1">
              {overflowTags.map((tag) => (
                <Tag key={tag.id} size={size} className="max-w-[120px]">
                  {tag.name}
                </Tag>
              ))}
            </div>
          }
        >
          <span>
            <Text variant="description" className="text-text-description">
              +{overflowCount}
            </Text>
          </span>
        </Tooltip>
      )}
    </div>
  );
};
